import { render, staticRenderFns } from "./BusinessesSelector.vue?vue&type=template&id=35664b28&scoped=true"
import script from "./BusinessesSelector.vue?vue&type=script&lang=js"
export * from "./BusinessesSelector.vue?vue&type=script&lang=js"
import style0 from "./BusinessesSelector.vue?vue&type=style&index=0&id=35664b28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35664b28",
  null
  
)

export default component.exports